var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandArcStyleBrand = function SvgBrandArcStyleBrand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_BrandArcStyleBrand__clip0_3952_113502)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.59 1.782a3.47 3.47 0 0 1 3.03 1.977l2.228 4.686.036-.09q.132-.351.217-.716l.031-.145a3.47 3.47 0 0 1 6.286-1.244 3.47 3.47 0 0 1 .515 2.604c-.5 2.499-1.79 4.817-3.64 6.655l-.06.056.782 1.642c.906 1.906-.033 4.21-2.007 4.857l-.089.027-.068.02a3.44 3.44 0 0 1-2.78-.406 3.47 3.47 0 0 1-1.28-1.443l-.604-1.267-.151.038c-.815.192-1.642.299-2.469.315l-.225.003c-.796 0-1.605-.093-2.413-.272l-.16-.037-.578 1.217a3.47 3.47 0 0 1-1.942 1.767l-.103.036a3.47 3.47 0 0 1-2.715-.233c-1.647-.875-2.274-2.923-1.471-4.615l.719-1.512-.063-.061C1.63 14.668.85 13.563.33 12.375l-.069-.163-.01-.026a3.47 3.47 0 0 1 1.917-4.512 3.47 3.47 0 0 1 3.88.898l.018.02 2.292-4.82a3.46 3.46 0 0 1 3.036-1.99h.197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A007F",
    d: "m8.167 17.723 2.053-4.319c-1.568-.333-3.145-1.303-4.038-2.483l-2.146 4.513a12.2 12.2 0 0 0 4.131 2.289"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E000A",
    d: "M16.734 10.792c-1.031 1.264-2.463 2.202-3.996 2.567l2.047 4.306a12.3 12.3 0 0 0 4.096-2.363z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A007F",
    d: "m4.036 15.434-1.073 2.257c-.547 1.147-.136 2.56.989 3.158a2.36 2.36 0 0 0 3.236-1.067l.98-2.059a12.25 12.25 0 0 1-4.132-2.289"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9396",
    d: "M20.995 5.865a2.356 2.356 0 0 0-2.774 1.85c-.226 1.131-.756 2.185-1.487 3.08l2.143 4.513c1.979-1.716 3.44-4.054 3.964-6.669a2.354 2.354 0 0 0-1.847-2.774"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002DC8",
    d: "M12.738 13.359a6 6 0 0 1-1.396.168c-.365 0-.744-.042-1.122-.123-1.568-.333-3.145-1.303-4.038-2.483a4 4 0 0 1-.53-.914 2.36 2.36 0 0 0-3.068-1.303 2.36 2.36 0 0 0-1.302 3.067c.552 1.371 1.529 2.629 2.754 3.663a12.2 12.2 0 0 0 4.128 2.289c1.038.333 2.114.517 3.175.517 1.176 0 2.337-.203 3.442-.575z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF536A",
    d: "m20.009 17.68-1.132-2.378-2.143-4.51-.003.003q0-.001.003-.003l-3.116-6.556a2.36 2.36 0 0 0-2.127-1.345c-.909 0-1.736.524-2.128 1.345l-3.177 6.685c.892 1.18 2.47 2.15 4.037 2.483l1.028-2.16a.269.269 0 0 1 .485 0l1.006 2.115h.006-.006l2.046 4.306 1.005 2.114a2.35 2.35 0 0 0 2.758 1.258c1.419-.392 2.091-2.024 1.458-3.356"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandArcStyleBrand__clip0_3952_113502"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandArcStyleBrand);
export { ForwardRef as ReactComponent };